<template>
    <div class="b2b-info-item">
        <div class="row">
            <div class="col-12 col-md-6 img-wrap">                
                <div v-if="src!='no-image'" class="img-wrap-inner--desctop" :style="'background-image:url(' + src_url + '/' + src.path + src.file_name + ')'">                  
                </div>
                <div class="img-wrap-inner--mobile">
                    <img v-if="src!='no-image'" 
                        :src="src_url + '/' + src.path + src.file_name" :alt="name" :title="name" 
                        :srcset="srcset"
                        sizes="(max-width: 767px) 100vw, 50vw"
                        class="img-fluid" 
                    />
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="text-wrap">
                    <div class="name">{{ name }}</div>
                    <div class="desc" v-html="description">{{description}}</div>
                    <div class="btn-wrap">
                        <router-link :to="{path: target_link}" v-if="!hasHttp(target_link)" class="btn btn--green-border">{{lang('b2bItem_btn_text')}}</router-link>
                        <a v-else :href="target_link" class="btn btn--green-border" target="_blank">{{lang('b2bItem_btn_text')}}</a>
                    </div>            
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },
    props:['name', 'description', 'target_link', 'src', 'srcset']    
}
</script>